import { Amplify } from 'aws-amplify';
import { AWSIoTProvider } from '@aws-amplify/pubsub';

export const initializeAmplify = async (token) => {
  const response = await fetch('https://api.yellowmatrix.co.in/vehiclelivedata', {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status} - ${response.statusText}`);
  }

  const config = await response.json();
  const { identityPoolId, region, mqttEndpoint } = config;

  Amplify.configure({
    Auth: {
      identityPoolId,
      region,
      mandatorySignIn: false
    }
  });

  Amplify.addPluggable(new AWSIoTProvider({
    aws_pubsub_region: region,
    aws_pubsub_endpoint: mqttEndpoint,
  }));
};
